import React from 'react';
import { MapPin, Phone, Mail, Clock, MessageCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

const WHATSAPP_NUMBER = '5594992013575';

export const Contact = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(`Olá! Gostaria de mais informações sobre o Hotel Del Rio.`);
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`, '_blank');
  };

  return (
    <div className="min-h-screen bg-background py-12" data-testid="contact-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-display font-bold text-primary mb-4">
            Entre em Contato
          </h1>
          <p className="text-text-secondary max-w-2xl mx-auto">
            Estamos aqui para ajudar. Fale conosco!
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <h2 className="text-2xl font-display font-semibold text-primary mb-6">
              Fale Conosco pelo WhatsApp
            </h2>
            <p className="text-text-secondary mb-6">
              Atendimento rápido e personalizado. Clique no botão abaixo para iniciar uma conversa.
            </p>
            <Button 
              onClick={handleWhatsAppClick} 
              className="w-full bg-primary hover:bg-primary/90 rounded-full py-6 text-lg" 
              data-testid="contact-whatsapp-button"
            >
              <MessageCircle className="h-5 w-5 mr-2" />
              Enviar mensagem no WhatsApp
            </Button>
          </div>

          <div className="space-y-8">
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <h2 className="text-2xl font-display font-semibold text-primary mb-6">
                Informações de Contato
              </h2>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <MapPin className="h-5 w-5 text-primary mt-1" />
                  <div>
                    <p className="font-semibold">Endereço</p>
                    <p className="text-text-secondary">Conceição do Araguaia - PA</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Phone className="h-5 w-5 text-primary mt-1" />
                  <div>
                    <p className="font-semibold">Telefone</p>
                    <p className="text-text-secondary">+55 94 99201-3575</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Mail className="h-5 w-5 text-primary mt-1" />
                  <div>
                    <p className="font-semibold">Email</p>
                    <p className="text-text-secondary">contato@hoteldelrio.com</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <Clock className="h-5 w-5 text-primary mt-1" />
                  <div>
                    <p className="font-semibold">Horário</p>
                    <p className="text-text-secondary">Check-in: 14h | Check-out: 12h</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white p-4 rounded-xl shadow-lg overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3976.0!2d-49.26!3d-8.26!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zOMKwMTUnMzYuMCJTIDQ5wrAxNSczNi4wIlc!5e0!3m2!1sen!2sbr!4v1234567890"
                width="100%"
                height="300"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                title="Hotel Del Rio Location"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
